"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.userPermissionMap = exports.ticketPermissionFormatMap = exports.UserPermission = void 0;
var Role_1 = require("../Role");
/**
 * Available user permissions
 */
var UserPermission;
(function (UserPermission) {
    UserPermission["List"] = "UserPermission.List";
    UserPermission["Manage"] = "UserPermission.Manage";
    UserPermission["Delete"] = "UserPermission.Delete";
    UserPermission["ResetPassword"] = "UserPermission.ResetPassword";
})(UserPermission = exports.UserPermission || (exports.UserPermission = {}));
/**
 * Human readable versions of our permission map
 */
exports.ticketPermissionFormatMap = (_a = {},
    _a[UserPermission.List] = "View all Users",
    _a[UserPermission.Manage] = "Amend the details of an User",
    _a[UserPermission.Delete] = "Delete Users",
    _a[UserPermission.ResetPassword] = "Reset User Password",
    _a);
/**
 * Out of the box user permissions.
 *
 * Admins can do everything
 * Standard users can only list other users.
 */
exports.userPermissionMap = (_b = {},
    _b[Role_1.Role.Admin] = __spreadArray([], Object.values(UserPermission)),
    _b[Role_1.Role.User] = [UserPermission.List],
    _b);
//# sourceMappingURL=UserPermissions.js.map